import React, { useState } from 'react';
import Spinner from '../Spinner';
import { toast } from 'react-toastify';
import axios from 'axios';

const EmailValidation = ({email, handleVerificationSuccess}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const handleVerify = (event) => {
    event.preventDefault();
    setIsLoading(true);
    axios.post(`/subscription/v1/verify-code`, {'email': email, 'verificationCode': verificationCode})
    .then((res) => {
      handleVerificationSuccess();
    }).catch((err) => {
      console.log(err)
      toast(err.response.data.error, {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
      });
    })
    .finally(() => {
      setIsLoading(false);
    })
  };

  const handleResendCode = (event) => {
    setIsLoading(true);
    event.preventDefault();
    axios.post(`/subscription/v1/email-verification`, {'customerEmail': email})
    .then((res) => {
    }).catch((err) => {
      console.log(err)
      toast(err.response.data.error, {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
      });
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  return (
    <>
      <div className="grid grid-cols-1 gap-4 justify-items-center mb-3">
        <span className="text-white font-bold text-xl sm:text-lg">Sign up to get started for free!</span>
      </div>

      <div className="grid grid-cols-1 gap-1 mb-5 px-2">
        <span className=" text-white font-light text-sm">Email</span>
        <input
          value={email}
          type="text"
          name="customerEmail"
          disabled
          className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
          ></input>
        <span className=" text-white font-light text-sm">Verification code</span>
        <input
          value={verificationCode}
          onChange={(e) => setVerificationCode(e.target.value)}
          type="text"
          name="verificationCode"
          className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
          ></input>
      </div>
      <div className="grid grid-cols-2 gap-1 mb-5 px-2 justify-items-center ">
        <button onClick={handleVerify} className="bg-8A8988 text-white font-bold text-base rounded-[12px] h-10 w-fit hover:bg-ETWOrange disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500 disabled:shadow-none dark:disabled:border-gray-700 dark:disabled:bg-gray-800/20 px-1" disabled={isLoading}>
          {isLoading ? <Spinner /> : 'Verify Code'}
        </button>

        <button onClick={handleResendCode} className="bg-8A8988 text-white font-bold text-base rounded-[12px] h-10 w-fit hover:bg-ETWOrange disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500 disabled:shadow-none dark:disabled:border-gray-700 dark:disabled:bg-gray-800/20 px-1" disabled={isLoading}>
          {isLoading ? <Spinner /> : 'Resend Code'}
        </button>
      </div>

      <div className="grid grid-cols-1 gap-1 ">
        <span className="text-white font-bold text-sm text-center">
          Did&lsquo;t get the email? Check your spam! of it&lsquo;s not there reach out to support@etw.com
        </span>
      </div>

    </>
  );
};

export default EmailValidation;